import { MDSTheme } from '@marqvision/mds/core';
import { PiracyCommonEnumsCrCRStatusEnum, PiracyCommonEnumsCrCRTypeEnum } from '~/swagger/data-contracts';

export const requestStatusLabel: Record<PiracyCommonEnumsCrCRStatusEnum, string> = {
  [PiracyCommonEnumsCrCRStatusEnum.InProgress]: 'In progress',
  [PiracyCommonEnumsCrCRStatusEnum.Completed]: 'Completed',
  [PiracyCommonEnumsCrCRStatusEnum.NotAvailable]: 'Not available',
};

export const requestStatusColor: Record<PiracyCommonEnumsCrCRStatusEnum, keyof typeof MDSTheme.palette> = {
  [PiracyCommonEnumsCrCRStatusEnum.InProgress]: 'teal',
  [PiracyCommonEnumsCrCRStatusEnum.Completed]: 'green',
  [PiracyCommonEnumsCrCRStatusEnum.NotAvailable]: 'red',
};

export const requestTypeLabel: Record<PiracyCommonEnumsCrCRTypeEnum, string> = {
  [PiracyCommonEnumsCrCRTypeEnum.AddWhitelist]: 'Add to whitelist',
  [PiracyCommonEnumsCrCRTypeEnum.Enforce]: 'Enforce',
  [PiracyCommonEnumsCrCRTypeEnum.ChangeAsset]: 'Change asset',
  [PiracyCommonEnumsCrCRTypeEnum.Retract]: 'Retract',
};

export const placeholdersByRequestType: Record<PiracyCommonEnumsCrCRTypeEnum, string> = {
  [PiracyCommonEnumsCrCRTypeEnum.AddWhitelist]: 'Please enter the url(s) to be added to whitelist.',
  [PiracyCommonEnumsCrCRTypeEnum.Enforce]: 'Please enter the url(s) to be enforced.',
  [PiracyCommonEnumsCrCRTypeEnum.ChangeAsset]: 'Please enter the asset(s) to be excluded and newly added.',
  [PiracyCommonEnumsCrCRTypeEnum.Retract]: 'Please enter the url(s) to be retracted.',
};